<template>
  <div class="mh_500 overflow-auto">
    <div
      class="position-relative image_box flex-center w-100"
      v-for="(item, index) in slides"
      :key="index"
    >
      <ImageBox
        :downloadCode="pathOr(null, ['download_code'], item)"
        parentTagClass="max-width-700"
        imageClass="w-100 h-auto img-fluid"
        :defaultImage="defaultImage"
        loadingClass="left-0 top-0 w-100 h-100"
        :hasPreview="false"
        wrapperClass="width-percent-100 flex-center"
        :imageBodyFullWidth="true"
      />
      <div
        v-text="generateCaption(item)"
        class="bg-dark text-white text-center p-2 mb-3 w-100 rounded-bottom caption_image"
      />
    </div>
  </div>
</template>

<script>
import { ImageBox } from "@/components/re-design";
import { generateConfig } from "@/shared/utils";
import { pathOr, includes } from "ramda";

export default {
  components: { ImageBox },
  props: {
    slides: {
      type: Array,
      default: () => [],
    },
  },
  data() {
    return {
      allowedTypes: ["jpg", "jpeg", "png"],
    };
  },
  computed: {
    filterSlides() {
      return this.slides.filter(
        (item) => item.url && includes(item.ext, this.allowedTypes)
      );
    },
    defaultImage() {
      return generateConfig(["images","shared", "noImage"]);
    },
  },
  methods: {
    pathOr,
    includes,
    generateCaption(item) {
      const caption = pathOr(null, ["caption"], item);
      const attachmentTypeCaption = pathOr(
        null,
        ["attachment_type", "caption"],
        item
      );
      return caption === attachmentTypeCaption
        ? caption
        : `${attachmentTypeCaption} - ${caption}`;
    },
  },
};
</script>
<style lang="scss" scoped>
.trans {
  transition: 0.7s ease;
  -webkit-transition: 0.7s ease;
  -moz-transition: 0.7s ease;
}
.mh_500 {
  max-height: 500px !important;
}
.caption_image {
  opacity: 0;
  position: absolute;
  bottom: 0;
  @extend .trans;
}
.image_box {
  @extend .trans;
  &:hover {
    @extend .trans;
    .caption_image {
      opacity: 0.7;
    }
  }
}
</style>
